import { companyProfileService } from '@services/requests/companyProfileService';
import { dealPageService } from '@services/requests/dealPageService';

export type DocumentServiceType = 'company-profile' | 'deal-page';

export function getDocumentService(type: DocumentServiceType) {
  switch (type) {
    case 'company-profile':
      const companyService = companyProfileService();
      return companyService.UploadDocument.bind(companyService);
    case 'deal-page':
      const dealService = dealPageService();
      return dealService.UploadDealDocument.bind(dealService);
    default:
      return null;
  }
}
